import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import useAlert from '@/composables/useAlert';

/**
 * Service for handling notification interaction
 * 
 * @returns {Object} - Functions for handling the notification
 */
export default () => {
    const router = useRouter();
    const i18n = useI18n();
    const alert = useAlert;
    
    // Function to handle notification action
    const handleAction = (notification) => {
        if (!notification || !notification.notification_type) {
            return;
        }
        
        // Handle different notification types
        switch (notification.notification_type) {
            case 'order_status':
                if (notification.data?.order_id) {
                    router.push({ name: 'pages.admin.orders.view', params: { id: notification.data.order_id } });
                }
                break;
                
            case 'new_order':
                if (notification.data?.order_id) {
                    router.push({ name: 'pages.admin.orders.view', params: { id: notification.data.order_id } });
                }
                break;
                
            case 'system':
                // Handle system notifications - may vary depending on sub-type
                if (notification.data?.product_id) {
                    router.push({ name: 'pages.admin.products.view', params: { id: notification.data.product_id } });
                }
                break;
                
            case 'assignment':
                // Handle assignment notifications
                if (notification.data?.order_id) {
                    router.push({ name: 'pages.admin.orders.view', params: { id: notification.data.order_id } });
                }
                break;
                
            default:
                console.log('Unknown notification type:', notification.notification_type);
        }
    };
    
    // Function to handle notification errors
    const handleError = (error) => {
        console.error('Notification error:', error);
        alert(i18n.t('errors.something-wrong-happened'), 'danger');
    };
    
    return {
        handleAction,
        handleError
    };
}; 